import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { RefreshCw, X, Loader2 } from 'lucide-react';
import { useServiceWorkerUpdate } from '../../hooks/useServiceWorkerUpdate';
import { useMediaQuery } from '../../hooks/useMediaQuery';

export const UpdateBanner: React.FC = () => {
  const { isUpdateAvailable, isUpdating, applyUpdate } = useServiceWorkerUpdate();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const [dismissed, setDismissed] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  if (!isUpdateAvailable || !isMobile || dismissed) return null;

  const handleDismiss = () => {
    setIsExiting(true);
    setTimeout(() => setDismissed(true), 200);
  };

  return createPortal(
    <div
      className={`
        fixed left-0 right-0 top-0 z-notification
        flex items-center gap-3
        px-4 py-3
        bg-sky-500 text-white
        transition-all duration-200 ease-out
        ${isExiting ? '-translate-y-full opacity-0' : 'translate-y-0 opacity-100'}
      `}
      role="status"
      aria-live="polite"
    >
      <RefreshCw className="w-4 h-4 shrink-0" />
      <span className="flex-1 text-sm font-medium">Update available</span>

      <button
        onClick={applyUpdate}
        disabled={isUpdating}
        aria-busy={isUpdating}
        aria-label={isUpdating ? 'Updating...' : 'Update now'}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md bg-white/20 border border-white/30 hover:bg-white/30 disabled:opacity-70 transition-colors"
      >
        {isUpdating ? (
          <>
            <Loader2 className="w-3.5 h-3.5 animate-spin" />
            <span>Updating...</span>
          </>
        ) : (
          'Update now'
        )}
      </button>

      <button
        onClick={handleDismiss}
        disabled={isUpdating}
        aria-label="Dismiss update notification"
        className="flex items-center justify-center w-11 h-11 -mr-2 text-white/80 hover:text-white disabled:opacity-50 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>,
    document.body
  );
};

export default UpdateBanner;
